import {Button, Grid} from '@mui/material';
import styles from 'assets/css/wizard.module.css';
import VisibilityIcon from 'assets/img/visibility_FILL0_wght400_GRAD0_opsz48 2.svg';
import CircularLoading from 'components/Loading/CircularLoading';
import useAgentInfo from 'hooks/useAgentInfo';

const CustomButton = ({activeStep, disabled, type}) => {
  const {data: agentInfo} = useAgentInfo();

  return (
    <Grid item>
      <Button
        type='submit'
        disableRipple
        disableFocusRipple
        disabled={disabled}
        className={styles.continueBtn}
        sx={{
          color: type === 'edit' ? '#6F4D9F !important' : '#FFFFFF !important',
          background:
            type === 'edit' ? '#F4F4F4 !important' : ' #753cbe !important',
          width:
            activeStep === 2 || type === 'edit' ? '100% !important' : '131px',
        }}
        startIcon={
          activeStep === 2 && (
            <img
              src={VisibilityIcon}
              alt=''
              style={{
                marginLeft: 'auto',
                position: 'absolute',
                right: 17,
                top: 10,
              }}
            />
          )
        }>
        {type === 'add' && (
          <div style={{display: 'grid', alignItems: 'center'}}>
            {!disabled && (
              <span>
                {activeStep === 1
                  ? 'ادامه'
                  : agentInfo?.isScanCenter
                  ? 'ثبت اطلاعات بیمار'
                  : 'ثبت اطلاعات بیمار برای پزشک'}
              </span>
            )}
            {disabled && (
              <div
                style={{display: 'grid', palceItems: 'center', width: '100%'}}>
                <CircularLoading width='20px' height='20px' color='#3CC0C3' />
              </div>
            )}
          </div>
        )}
        {type === 'edit' && 'ثبت'}
      </Button>
    </Grid>
  );
};

export default CustomButton;
